import requests from "./httpService";

const MinDurationServices = {
  getAllMinDuration: async (body) => {
    return requests.get(`/minduration/`);
  },

  updateminDuration: async (id, body) => {
    return requests.put(`/minduration/${id}`, body);
  },

  getMinDurationByid: async (id) => {
    return requests.get(`/minduration/getminduration/${id}`);

  },

  updatedurationStatus: async (id, body) => {
    return requests.patch(`/minduration/updatestatus/${id}`, body);
  }
};

export default MinDurationServices;
